<template>
    <b-modal id="modal-add-table-view" centered no-close-on-backdrop no-close-on-esc
        :footer-class="'d-block p-3 m-0'" :body-class="'px-3 pt-3 pb-1'" @shown="onShown">
        <template #modal-header="{ close }">
            <h5 class="modal-title">{{ $t('addTableView.title') }}</h5>
            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">{{ $t('addTableView.close') }}</b-button>
        </template>
        <div class="body">
            <b-form-group :label="$t('addTableView.nameLabel')" class="text-left mb-0">
                <b-form-input v-model="name" :placeholder="$t('addTableView.namePlaceholder')" class="unit f-12" ref="nameInput"
                    @keyup.enter="save()" />
                <p v-if="error" class="field-error">{{ error }}</p>
            </b-form-group>
        </div>
        <template #modal-footer>
            <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
                <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="secondary" @click="cancel()">{{ $t('addTableView.cancel') }}</b-button>
                <b-button class="mx-0 h-40px w-100px m-0" variant="primary" @click="save()">{{ $t('addTableView.save') }}</b-button>
            </div>
        </template>
    </b-modal>
</template>
<script>
import { mapActions } from "vuex";
export default {
    name: "AddTableViewModal",
    props: {
        table: { type: String, required: true },
        seedColumns: { type: Array, default: () => [] },
        seedFilters: { type: String, default: "" },
    },
    data() {
        return {
            name: "",
            error: "",
        };
    },
    methods: {
        ...mapActions(["addTableView", "setNotification", "setLoader"]),
        onShown() {
            this.name = "";
            this.error = "";
            this.$nextTick(() => {
                if (this.$refs.nameInput) this.$refs.nameInput.focus();
            });
        },
        cancel() {
            this.$emit("cancel");
            this.$bvModal.hide("modal-add-table-view");
        },
        async save() {
            const trimmed = (this.name || "").trim();
            if (!trimmed) {
                this.error = this.$t('addTableView.nameRequired');
                return;
            }
            try {
                this.setLoader(true);
                const view = await this.addTableView({
                    table: this.table,
                    payload: {
                        name: trimmed,
                    columns: this.seedColumns.map(c => ({ key: c.key, visible: !!c.visible })),
                        filters: "",
                    },
                });
                this.setLoader(false);
                await this.setNotification({
                    msg: this.$t('addTableView.viewCreated', { name: view.name }),
                    type: "success",
                    color: "green",
                });
                this.$bvModal.hide("modal-add-table-view");
                this.$emit("created", view);
            } catch (e) {
                this.setLoader(false);
                if (typeof e === "object" && e.name) {
                    this.error = Array.isArray(e.name) ? e.name[0] : e.name;
                } else if (typeof e === "object" && e.detail) {
                    this.error = e.detail;
                } else {
                    this.error = typeof e === "string" ? e : this.$t('addTableView.createFailed');
                }
            }
        },
    },
};
</script>
